import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`Purpose of this chapter is to help our users to identify the major changes he/she should notice before upgrading his/her existing application. It's always recommended to keep the `}<inlineCode parentName="p">{`current site & database backup`}</inlineCode>{` before any upgradation. `}</p>
    <h2 {...{
      "id": "breaking-change-log-version-1100"
    }}>{`Breaking Change Log Version: 11.0.0`}</h2>
    <p>{`Some new exiciting feature is added like Flash sale, FAQs builder for super admin & vendor shop, Terms & Condition builder etc. For that reason there were some changes introduced in the database level along with API, Admin & Shop end. Here is the given key points to know before any upgradation, `}</p>
    <pre><code parentName="pre" {...{}}>{`- Pickbazar admin dashboard design facelifted
- Dashboard analytics section updated along with new analytics widgets
- Settings page is divided into multi parts.
- Flash sale builder added
- Terms & Condition builder added
    - Super admin can perform CRUD operation
    - Vendor also can perform CRUD operation if and only if super admin enable this feature from settings.
- FAQs builder added
    - Super admin can add FAQs for global scope
    - Vendor can add FAQs based on his each shop
- Refund policy builder added
- Refund reason builder added, so that Super Admin can preset some refund reasons during customer asking for any refund.
- Product inventory route added
- Order transaction route added for better viewing about the recent transactions.
- User section divided into multiple layer for better management.
`}</code></pre>
    <p>{`Some new database table is introduced along with some older table modification. So it's always safe to keep your existing database backup, then run migration for getting the new changes. `}</p>
    <h2 {...{
      "id": "breaking-change-log-version-1000"
    }}>{`Breaking Change Log Version: 10.0.0`}</h2>
    <pre><code parentName="pre" {...{}}>{`-Set SMS Events from settings for Admin, Vendor & Customer. [New Feature]
- Set Email Event from settings for Admin, Vendor & Customer. [New Feature]
- Email Event Setting option [New Feature]
- SMS Settings for both Graphql and REST [New Feature]
- Added Setting Seeder [New Feature]
- New Console Command marvel:settings_seed [New Feature]
- Added Settings Dummy data seeder command [New Feature]
- Added OpenAI support in every possible description like Create Shop → Description, Create Manufacturer/Publication → Description, Create New Category → Details,Add Tag → Details, Create Author → Bio, Create Author → Quote, Create New Coupon → Bio, Create New Coupon → Description, Settings → Meta Description, Settings → OG Description [New Feature]
- Added Video attribute for a product. [Enhancement]
- Order cancel Recalculate [Enhancement]
- Order Note attribute added for Order [Enhancement]
- Guest Checkout Enable/Disable option on setting. [Enhancement]
-. Video Preview in Single Product view page.[Enhancement]
- Handled Unused Order Creation and other minor [Issue Fix]
- Fixed Settings issue [Issue Fix].
- Search Page redirection issue fixed.[Issue Fix].
- Next router URL issue fixed on search component[Issue Fix].
- Homepage control issue fixed[Issue Fix].
`}</code></pre>
    <h2 {...{
      "id": "breaking-change-log-version-800"
    }}>{`Breaking Change Log Version: 8.0.0`}</h2>
    <pre><code parentName="pre" {...{}}>{`- Upgraded Pickbazar API to Laravel 10 & all other packages
- Upgraded Pickbazar Admin to Next JS 13 & all other packages
- Upgraded Pickbazar Shop to Next JS 13 & updated all other packages
- Fixed permission issue
- Fixed Slug issue
`}</code></pre>
    <h2 {...{
      "id": "breaking-change-log-version-600"
    }}>{`Breaking Change Log Version: 6.0.0`}</h2>
    <pre><code parentName="pre" {...{}}>{`- Upgrade API to laravel 9
- Restructure the entire payment gateway system
- Added Stripe (Intent Based) and PayPal payment gateway
- Added card management feature
- Removed omnipay packages
- Added support for status-based inventory management option
- Added balance dispatch option based on status
- Added option to disable cash on delivery system
- Added product slug edit feature
- Fixed docker zip extension issue
- Fixed wallet points order issue
- Fixed order fail issue
- Fixed excel package cache issue
- Fixed user block and vendor inactive issue
- Fixed blank order created issue
- Fixed repeated new user wallet add issue for OTP login
- Fixed negative subtotal for coupon
`}</code></pre>
    <h2 {...{
      "id": "breaking-change-log-version-500"
    }}>{`Breaking Change Log Version: 5.0.0`}</h2>
    <pre><code parentName="pre" {...{}}>{`- Multilingual support added
- Added toast notification after payment confirmation
- Fixed invoice issue for Unicode language
- Fixed wallet issue for social login
- Fixed file upload security issue
- Fixed book demo search page broken issue
- Fixed few minor bugs
`}</code></pre>
    <h2 {...{
      "id": "breaking-change-log-version-200"
    }}>{`Breaking Change Log Version: 2.0.0`}</h2>
    <pre><code parentName="pre" {...{}}>{`- Multivendor support
- Single owner multiple shop
- Withdraws
- Order Management
- Shop Management
- Staff Management
- Product Management
- Attribute Management
- Shop Archives
- Shop details
- Internationalization support with RTL
- Product Tags support
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      